export interface ACHDiscountData {
  achDiscountCode: string;
  achDiscountOverriden: boolean;
  achDiscountPeriodInMonths: number;
  achDiscountedPercentage: number;
}
